import styled from 'styled-components';

//components
import { Container } from '@/components/Grid';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const HeroSection = styled.header`
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid ${homeColor.carbon};
  background: ${homeColor.bg};
`;

export const HeroBg = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

export const HeroVisual = styled.img.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    prop === 'fetchpriority' || defaultValidatorFn(prop),
})`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 75% center;
  opacity: 0.55;

  ${screen.lg} {
    object-position: 85% center;
    opacity: 0.85;
  }
`;

export const HeroBgFade = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    ${homeColor.bg} 0%,
    ${homeColor.bg} 35%,
    rgba(7, 19, 24, 0) 78%
  );

  ${screen.lg} {
    background: linear-gradient(
      90deg,
      ${homeColor.bg} 0%,
      ${homeColor.bg} 40%,
      rgba(7, 19, 24, 0) 82%
    );
  }
`;

export const HeroInner = styled(Container)`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding-top: 40px;
  padding-bottom: 40px;

  ${screen.lg} {
    padding-top: 80px;
    padding-bottom: 80px;
  }
`;

export const HeroTitle = styled.h1`
  font-family: ${getToken('font-family-title')};
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.12;
  font-size: 36px;
  margin: 0;
  color: ${homeColor.white};
  text-align: center;

  ${screen.md} {
    text-align: left;

    br {
      display: block;
    }
  }

  ${screen.lg} {
    font-size: 50px;
    line-height: 1.12;
  }
`;

export const HeroDescription = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 500;
  font-size: 17px;
  line-height: 1.6;
  color: ${homeColor.muted};
  margin: 0;
  text-align: center;

  ${screen.md} {
    text-align: left;
    max-width: 460px;
  }
`;

export const HeroMetric = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  border-top: 1px solid ${homeColor.line};
  padding-top: 16px;
  text-align: center;

  ${screen.md} {
    flex-direction: row;
    align-items: center;
    gap: 22px;
    text-align: left;
  }
`;

export const HeroMetricValue = styled.p`
  font-family: ${getToken('font-family-title')};
  font-weight: 800;
  letter-spacing: -0.03em;
  font-size: 60px;
  line-height: 1;
  margin: 0;

  ${screen.xxlg} {
    font-size: 70px;
  }
`;

export const HeroMetricText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const HeroMetricLabel = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 500;
  font-size: 14px;
  color: ${homeColor.muted};
  margin: 0;
`;

export const HeroMetricSource = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 600;
  font-size: 11px;
  letter-spacing: 0.09em;
  color: ${homeColor.muted2};
  margin: 0;
`;

export const HeroCta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: center;
  padding-top: 12px;

  ${screen.md} {
    justify-content: flex-start;
  }
`;
